import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ActionsService, ErrorService, EvaluationsService, LoginService, StorageManagerService, UserService } from './services';

export function provideCoreServices(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: ErrorService, useClass: ErrorService },
    { provide: LoginService, useClass: LoginService },
    { provide: ActionsService, useClass: ActionsService },
    { provide: StorageManagerService, useClass: StorageManagerService },
    { provide: UserService, useClass: UserService },
    { provide: EvaluationsService, useClass: EvaluationsService }
  ]);
}
